import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-events-events',
  templateUrl: './events-events.component.html',
  styleUrls: ['./events-events.component.scss']
})
export class EventsEventsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
